import I18n from 'I18n';
import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { useRequestSeatModalData } from './useRequestSeatModalData';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UISelect from 'UIComponents/input/UISelect';
import UITextArea from 'UIComponents/input/UITextArea';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { RequestAccessModalWrapper } from '../../RequestAccessModalWrapper';
import { UIAUMetrics } from '../../_core/utils/metricUtils';
import { trackClickedRequestSeatButton, trackViewedRequestSeatButton } from './request-seat-trackers';
import { requestSeatUpgrade } from './requestSeatApi';
//@ts-expect-error upstream is not TS
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UIRequestSeatButton = props => {
  const {
    level,
    showSeatSelector,
    upgradeData,
    usageLimitBannerData
  } = props;
  const correctedApiName = upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  const [localAlertStore] = useState(() => {
    return FloatingAlertStore.newFloatingAlertStore();
  });
  const requestSeatModalData = useRequestSeatModalData();
  const [requestReason, setRequestReason] = useState();
  const [selectedSeatType, setSelectedSeatType] = useState(correctedApiName ? null : requestSeatModalData.defaultSeat);
  const metricTrackingDetails = {
    // cast as a string because apiName will always be available for seated products
    // and metric js will throw an error
    apiName: upgradeData.apiName,
    isEmbeddedInBanner: usageLimitBannerData ? 'true' : 'false'
  };
  const handleClickRequestSeat = () => {
    UIAUMetrics.counter('request-seat-click', metricTrackingDetails).increment();
    trackClickedRequestSeatButton({
      upgradeData,
      level,
      usageLimitBannerData
    });
  };
  useEffect(() => {
    trackViewedRequestSeatButton({
      upgradeData,
      level,
      usageLimitBannerData
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFloatingAlertList, {
      alertStore: localAlertStore
    }), /*#__PURE__*/_jsx(RequestAccessModalWrapper, {
      buttonClassName: props.className,
      buttonUse: props.use || 'primary',
      buttonSize: props.size,
      floatingAlertStore: localAlertStore,
      requestAccessPromise: () => {
        const requestSeatPromise = requestSeatUpgrade({
          apiName: correctedApiName,
          requestReason,
          requestedSeatType: selectedSeatType
        });
        requestSeatPromise.then(__response => {
          UIAUMetrics.counter('request-seat-success', metricTrackingDetails).increment();
        }).catch(error => {
          UIAUMetrics.counter('request-seat-failure', Object.assign({}, metricTrackingDetails, {
            message: error.message
          })).increment();
        });
        return requestSeatPromise;
      },
      usageTrackingProperties: {
        apiName: correctedApiName,
        apiNames: [correctedApiName],
        modalType: 'requestSeatUpgrade',
        screen: upgradeData.screen,
        source: upgradeData.source || '',
        upgradeProduct: upgradeData.upgradeProduct,
        upgradeProducts: [upgradeData.upgradeProduct],
        app: upgradeData.app,
        uniqueId: upgradeData.uniqueId,
        upgradeSource: upgradeData.upgradeSource || ''
      },
      modalWidth: 480,
      onClickOpenModal: handleClickRequestSeat,
      OpenModalButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.requestSeatButton"
      }),
      ModalBody: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(UIFlex, {
          direction: "column",
          justify: "between",
          align: "center",
          className: "m-bottom-4",
          children: [/*#__PURE__*/_jsx(UIIllustration, {
            name: "lock",
            className: "m-bottom-4",
            height: 60
          }), /*#__PURE__*/_jsx("p", {
            style: {
              fontWeight: 500
            },
            className: "m-bottom-0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.requestSeatModal.body.title"
            })
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.requestSeatModal.body.subtitle"
          })]
        }), showSeatSelector || !correctedApiName && requestSeatModalData.availableSeatOptions.length > 0 ? /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.requestSeatModal.seatInputSelect.title"
          }),
          children: /*#__PURE__*/_jsx(UISelect, {
            "data-test-id": `admin-only-modal-requestSeatUpgrade-new-seat-selector`,
            className: "m-bottom-4",
            onChange: event => {
              setSelectedSeatType(event.target.value);
            },
            options: requestSeatModalData.availableSeatOptions,
            defaultValue: requestSeatModalData.defaultSeat
          })
        }) : null, /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.requestSeatModal.reasonInput.header"
          }),
          children: /*#__PURE__*/_jsx(UITextArea, {
            value: requestReason,
            onChange: event => {
              setRequestReason(event.target.value);
            },
            placeholder: I18n.text('upgrades.requestSeatModal.reasonInput.placeholder')
          })
        })]
      }),
      ModalTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.requestSeatModal.title`
      }),
      SubmitRequestButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.adminModal.requestSeatUpgrade.button`
      })
    })]
  });
};
export default UIRequestSeatButton;